class InputLocalStorage {
  inputNames = {};
  constructor(inputNames) {
    this.inputNames = inputNames;
  }
  get getInputNames() {
    return Object.values(this.inputNames);
  }
  get isDataInLS() {
    return this.getInputNames.some((item) => {
      return localStorage.getItem(item);
    });
  }
  getValueFromLS(inputName) {
    const LSvalue = localStorage.getItem(inputName);
    return LSvalue ? LSvalue : "";
  }
  resetLocalStorage() {
    this.getInputNames.forEach((item) => {
      localStorage.removeItem(item);
    });
    return this;
  }
}

export { InputLocalStorage };
